export default "__VITE_ASSET__04d7dd9f__"